import BaseCommand from "@/models/api/commands/BaseCommand";

export class RemoveAttributeCommand extends BaseCommand {
  CommandName = "RemoveAttribute";
  Command: { TmpId: string | null; AttributeTmpId: string };
  constructor(sessionId: string, operationId: string, tmpId: string | null, attributeTmpId: string) {
    super(sessionId, operationId);
    this.Command = { TmpId: tmpId, AttributeTmpId: attributeTmpId };
  }
}
